module.exports = {
	"articleTitle1": "A new kind of 'Roméo et Juliette' at the Power Center ",
	"catImage": "yellowstar.png",
	"totalCats": 1,
	"name": "Power Center for the Performing Arts",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/section/arts/spring-awakening-preview",
	"articleSnippet1": "Nov 9, 2016 ... Daily Arts Writer ... “Roméo et Juliette,” at the Power Center for the Performing \nArts. Shakespeare's classic tragedy is brought to life by the ...",
	"articleSnippet2": "Nov 16, 2015 ... Power Center for the Performing Arts. Presale: $7/Students, $13/Adults. At the \ndoor: $10/Students, $15/Adults. Cue the lights, the curtains and ...",
	"totalMisc": 0,
	"articleTitle2": "MUSKET brings emotionally charged 'Spring Awakening' to Power ...",
	"address": "121 Fletcher St, Ann Arbor, MI 48109",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160325/mjv.NEW_.HONY_.4.24.16.106_0.jpg?itok=elseXUXs",
			"author": "Matt Vailliencourt",
			"caption": "Brandon Stanton, creator of \"Humans of New York,\" speaks about his experiences interviewing and photographing strangers at the Power Center on Thursday."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160405/eef.NEW_.TEDXUofM.4.1.16.084.jpg?itok=Jbhw8vp1",
			"author": "Emilie Farrugia",
			"caption": "Syrian attorney Khawla Wakkaf shares her desire to alleviate suffering in her community at the 7th Annual TEDxUofM Conference at the Power Center on Friday."
		}
	],
	"position": {
		"lat": 42.280773,
		"lng": -83.735823
	},
	"tips": [
		{
			"text": "It's a pretty cool place for speakers/performances. The architecture inside is very interesting.",
			"person": "Erik Forkin"
		}
	],
	"bathroomrating": [],
	"categories": {
		"livemusic": 1,
		"location": 1,
		"entertainment": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/powercenter.json
// module id = 951
// module chunks = 0